import {Form, Button, TextField} from '@/core'
import {TypeaheadPurposelyField} from '@c/form/typeahead-purposely-field'
import {useAdminAddNonprofitOwner} from '@/utils/drf/hooks'
import {doc} from './doc'
import styles from './style.module.styl'

export const AdminAddNonprofitOwner = doc(
	({}) => {
    const mutation = useAdminAddNonprofitOwner()
    const form = {
      name: 'adminAddNonprofitOwner',
      validations: {
        email: x => !x && 'Required.',
        nonprofit: x => !x && 'Required.'
      },
      onSubmit: data => mutation.mutateAsync(data)
    }
		return (
      <Form {...form} >
				<TextField type='email' placeholder='Email' name='email' />
        <TypeaheadPurposelyField name='nonprofit' type='adminNonprofit' />
        <Button>Set Owner</Button>
			</Form>
    )
	}
)
